import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Homepage from "pages/homepage";
import PracticeAreasOverview from "pages/practice-areas-overview";
import ContactUs from "pages/contact-us";
import TeamProfiles from "pages/team-profiles";
import AboutUs from "pages/about-us";
import IndividualPracticeAreaDetail from "pages/individual-practice-area-detail";
import EmploymentLaborLaw from "pages/employment-labor-law";
import CivilLitigation from "pages/civil-litigation";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/practice-areas-overview" element={<PracticeAreasOverview />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/team-profiles" element={<TeamProfiles />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/individual-practice-area-detail" element={<IndividualPracticeAreaDetail />} />
        <Route path="/employment-labor-law" element={<EmploymentLaborLaw />} />
        <Route path="/civil-litigation" element={<CivilLitigation />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;